<template>
  <div class="tab-pane photo-documentation-content active w-100 pl-0 pl-lg-3" id="dtab5" role="tabpanel">
    <div class="pb-1">
      <span class="photoicon">
        <i class="fa fa-picture-o" aria-hidden="true"></i>
        <span>{{selectedPhotos.length}}</span>
      </span>
     <span style="font-size: 15px">
       {{$t('photos')}}
     </span>
      <div v-if="doc.reporttype == '1'" class="sorting-photos float-right mr-3 mr-md-2">
        <div class="dropdown sorting mr-md-3 mr-4">
          <button class="dropdown-toggle sorting-dropdown-btn" type="button" id="dropdownMenuButton"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span v-if="sort === 'd_asc'"> <span class="pr-1">Datum</span>  <span class="px-1">&#8593;</span> </span>
            <span v-else-if="sort === 'd_dsc'"> <span class="pr-1">Datum</span>  <span class="px-1">&#x2193;</span> </span>
            <span v-else-if="sort === 'n_asc'">  <span class="pr-1">Nummer</span>  <span class="px-1">&#8593;</span> </span>
            <span v-else-if="sort === 'n_dsc'">  <span class="pr-1">Nummer</span>  <span class="px-1">&#x2193;</span> </span>
            <span v-else-if="sort === 'custom'">  <span class="pr-1">Individuell</span> </span>
            <span v-else>  <span class="pr-2">Sortierung</span> </span>
          </button>
          <div class="dropdown-menu order-by shadow-sm" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" @click.prevent="sortByDateAsc"  href="#">
            <span class="mrk" :class="{'visible': sort === 'd_asc'}">✓</span>  <span class="pl-1">Datum</span>  <span class="pl-1">&#8593;</span>
            </a>
            <a class="dropdown-item" @click.prevent="sortByDateDesc" href="#">
              <span class="mrk" :class="{'visible': sort === 'd_dsc'}">✓</span>  <span class="pl-1">Datum</span>  <span class="pl-1">&#x2193;</span>
            </a>
            <a class="dropdown-item" @click.prevent="sortByIdAsc"  href="#">
              <span class="mrk" :class="{'visible': sort === 'n_asc'}">✓</span>  <span class="pl-1">Nummer</span>  <span class="pl-1">&#8593;</span>
            </a>
            <a class="dropdown-item" @click.prevent="sortByIdDesc" href="#">
              <span class="mrk" :class="{'visible': sort === 'n_dsc'}">✓</span>  <span class="pl-1">Nummer</span>  <span class="pl-1">&#x2193;</span>
            </a>
            <a class="dropdown-item" @click.prevent="sort = 'custom'" href="#">
              <span class="mrk" :class="{'visible': sort === 'custom'}">✓</span>  <span class="pl-1">Individuell</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="details-tabs pr-4 pr-md-1 zero-index w-100 border-top mt-2">
      <div class="col-md-12 pt-1 zero-index pr-1">
        <div class="col-12 pr-2 pl-0 mt-2">
          <draggable :disabled="doc.reporttype == '0'" :forceFallback="true" @change="sort = 'custom'" v-model="selected_photos" class="draggable zero-index row"  @start="drag = true"  @end="drag = false">
           <div class="section-images simple-photo col-md-6 col-xl-4 pr-2 pl-0 mb-2 mb-1" v-for="(image , index) in sortedPhotos" :key="image.pdphotoid">
              <PhotoInfoPopup :photo="image" :isConstruction="false"/>
             <div v-if="doc.reporttype == '1'" @click="unCheckImage(index)" class="position-absolute remove-img" style="display: none">
               <img src="@/assets/images/delete_icon.png" data-value="btn" alt="remove" class="img-fluid"   title="Löschen" style="width: 20px">
             </div>
              <div :class="{'draggable-photo': sort === 'custom'}"  data-aspect-ratio="4:3" class="img-fluid position-relative" :title="sort === 'custom' ? 'Drag to change position' : ''">
                <div :style="{'background-image': 'url(\'' + getImagePath(image) + '\')'}"></div>
                <div class="simple-photo-option">
                  <ul>
                    <li>Nr.{{image.runid}}</li>
                    <li>|</li>
                    <li>{{ date(image.photodate) }}  </li>
                    <li>|</li>
                    <li>{{image.photodate.substring(11,16)}}  <span class="d-md-none d-lg-inline-block">Uhr</span>    </li>
                  </ul>
                </div>
              </div>
            </div>
        </draggable>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-1  pl-0 border-top" v-if="doc.reporttype == '1'">
      <button class="btn bg-light border border-secondary text-dark" data-toggle="modal" data-target=".bd-example-modal-lg">
        Fotos hinzufügen
      </button>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import {mapState} from 'vuex'
import {formatDate} from '../../common'
import PhotoInfoPopup from '../../constructionDiary/components/SideBar/PhotoInfoPopup'

export default {
  data () {
    return {
      is_draggable: false,
      drag: false,
      // sort: 'd_asc',
      sort: 'custom',
    }
  },
  components: {
    PhotoInfoPopup,
    draggable
  },
  mounted() {
    if (this.doc.reporttype != '1' || this.$route.name === 'photoDocumentCreate'){
      this.sort = 'd_asc';
    }
  },
  computed: {
    ...mapState({
      photos : state => state.photo.photos,
    }),
    selected_photos: {
      get(){
        if (this.doc.reporttype == '1'){
          return this.$store.state.photoDocumentation.selectedImages
        }else {
          return this.$store.state.photoDocumentation.dailyReportPhotos
        }
      },set(val){
        if (this.doc.reporttype == '1'){
          this.$store.commit('setSelectedImages',val)
        }else {
          this.$store.commit('setDailyReportPhotos',val)
        }
      }
    },
    doc(){
      if (this.$route.name === "photoDocumentEdit"){
        return this.$store.state.photoDocumentation.selectedDocument
      }else {
        return  this.$store.state.photoDocumentation.newDocumentDetails
      }
    },
    selectedPhotos() {
      if (this.doc.reporttype == '0') {
        return this.$store.getters.getDailyReportPhotos
      } else {
        return this.$store.state.photoDocumentation.selectedImages
      }
    },
    sortedPhotos() {
      let sortFunc;
      switch (this.sort) {
        case 'd_dsc':
          sortFunc = (a, b) => new Date(b.photodate.replaceAll('-', '/')) - new Date(a.photodate.replaceAll('-', '/'));
          break;
        case 'd_asc':
          sortFunc = (a, b) => new Date(a.photodate.replaceAll('-', '/')) - new Date(b.photodate.replaceAll('-', '/'));
          break;
        case 'n_asc':
          sortFunc = (a, b) => a.runid - b.runid;
          break;
        case 'n_dsc':
          sortFunc = (a, b) => b.runid - a.runid;
          break;
      }
      return this.selected_photos.sort(sortFunc);
    },
  },
  methods: {
    getImagePath(photo) {
      const projectid = this.$route.params.id
      return `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${projectid}&id=${photo.pdphotoid}&token=${localStorage.sessiontoken}&PHPSESSID=${localStorage.sessiontoken}`
    },
    date: (date) => formatDate(date),
   async unCheckImage (index) {
     await this.$store.commit('unSelectImage', index)
    },
    sortByDateDesc () {
      this.sort = 'd_dsc'
    },
    sortByDateAsc () {
      this.sort = 'd_asc'
    },
    sortByIdAsc () {
      this.sort = 'n_asc'
    },
    sortByIdDesc () {
      this.sort = 'n_dsc'
    },
    allowDrag () {
      this.is_draggable = true
    }
  }
}
</script>
<style>
.photo-documentation-content .sorting-photos .sorting button{
  text-align: center;
  border: 1px solid lightgrey;
  padding: 6px;
  margin-top: -7px;
  border-radius: 4px;
  font-size: 14px;
  height: 35px;
  line-height: 20px;
  min-width: 162px;
  background: white;
  width: auto;
  padding-inline: 25px;
}
.sorting-dropdown-btn::after{
  font-size: 1.5rem;
}
.draggable-photo{
  cursor: move;
}
.draggable .section-images:hover i{
  display: block !important;
  cursor: pointer !important;
  font-size: 18px;
  z-index: 999;
}
.draggable .section-images:hover .remove-img{
  display: block !important;
  cursor: pointer !important;
  z-index: 999;
}
.draggable .section-images .remove-img{
  top: 5px;
  left: 4px;
}
.draggable .photoinfobtn {
  right: 10px;
}
h5 a{
  padding-bottom: 5px;
}
#dtab5 .dropdown-menu{
  transform: none !important;
  left: 0 !important;
  top: 36px !important;
}
.simple-photo-option.photo{
  max-width: 95%;
  margin-bottom: 4px;
}
.details-tabs{
  height: calc(90vh - 189px);
  overflow-y: auto;
}
.details-tabs::-webkit-scrollbar-track{
  border-radius: 10px;
  background-color: #ffffff;
}
.details-tabs::-webkit-scrollbar-thumb{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.6);
  background-color: #3399ff9e;
  opacity: 1;
}
.details-tabs::-webkit-scrollbar{
  width: 6px;
  background-color: #ffffff;
}
.dropdown-menu.order-by span.mrk{
  visibility: hidden;
}
.dropdown-menu.order-by span.visible{
  visibility: visible;
}
.col.section-images.simple-photo .draggable-photo{
  z-index: 9;
}
@media (max-width: 1000px){
.photo-documentation-content .sorting-photos .sorting button {
  width: 140px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/PhotosTab.vue